import React, { useEffect, useState } from 'react';
import { GetCountries } from '../Country';
import { useTranslation } from "react-i18next";
import FilteringSelect from './common/FilteringSelect';
import { useSelector } from 'react-redux';
import { searchCompanies } from '../store/Actions';
import { copyProperties, deepEquals, isEmpty } from '../Util';
import BuyerSearchResult from './BuyerSearchResult';
import Spinner from './common/Spinner';

const BuyerForm = () => {

    const [formData, setFormData] = useState({
        companyName: '',
        companyVATNumber: '',
        address: {
            postalCode: '',
            city: '',
            countryCode: '',
            streetNumber: '',
            streetName: ''
        }
    });

    const buyerInfo = useSelector((state) => state.Reducer?.buyerAdditionalInformation);
    const [isPopinVisible, setIsPopinVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { t, i18n } = useTranslation();
    const [searchResult, setSearchResult] = useState(null);
    const [isValidationError, setIsValidationError] = useState(false);
    const [isTvaValidationError, setIsTvaValidationError] = useState(false);
    const dropdownCountries = GetCountries(i18n.language.toUpperCase()); 

    const PrefilledBuyerInfo = {
        companyName: buyerInfo.companyName,
        companyVATNumber: buyerInfo.companyVATNumber,
        address: {
            city: buyerInfo.address?.city,
            countryCode: buyerInfo.address?.countryCode,
        }
    }

    useEffect(() => {
        if (buyerInfo) {
            const filledFormData = { ...formData };           
            copyProperties(PrefilledBuyerInfo , filledFormData);
            setFormData(filledFormData);
        }
    }, []);

    const handleChange = (e) => {
        setIsTvaValidationError(false)
        const { name, value } = e.target;
        if (name.includes(".")) {
            const [parent, child] = name.split(".");
            setFormData((prevState) => ({ ...prevState,
            [parent]: {...prevState[parent], [child]: value} }));
        } else
            setFormData((prevState) => ({...prevState, [name]: value }));
    };

    const handleSearch = async (e) => {
        e.preventDefault();
        setIsValidationError(false);       
        if(!deepEquals(PrefilledBuyerInfo, formData)) 
            setIsValidationError(true);
        else{
            setIsLoading(true);
            await searchCompanies({
                companyName: formData.companyName,
                companyVATNumber: formData.companyVATNumber,
                address: {
                    postCode: formData.address?.postalCode,
                    city: formData.address?.city,
                    countryCode: formData.address?.countryCode,
                    streetNumber: formData.address?.streetNumber,
                    streetName: formData.address?.streetName
                }}, (result) => { setSearchResult(result); setIsPopinVisible(true);}, 
                    () => setIsTvaValidationError(true));
            setIsLoading(false);
        }
    };
    
    const closePopin = () => {
        setIsPopinVisible(false);
    }

    return (
        <>
            <form className="d-flex row justify-content-center">
                <div className="az-pay-title">
                    {t("buyerSearch.title")}
                </div>
                <div className="middle-font az-pay-subtitle">    
                    {t("buyerSearch.subtitle")}
                </div>
            
                <div className='row mt-1'>
                    <div class="az-formfield">
                        <input 
                            id="companyName"
                            name="companyName"
                            value={formData.companyName}
                            placeholder=""
                            onChange={handleChange}
                            disabled={!isEmpty(buyerInfo.companyName)}
                            className="az-formfield__input"                            
                        />
                        <label className="az-formfield__label" htmlFor="companyName">{t("buyerSearch.companyName.label")}</label>
                    </div>
                </div>
                

                <div className='row'>
                    <div className="col-sm-12 col-md-6 az-formfield">
                    
                        <input
                            type="text"
                            id="address.streetName"
                            name="address.streetName"
                            value={formData.address.streetName}
                            onChange={handleChange}
                            placeholder=""
                            className="az-formfield__input"
                            />

                        <label htmlFor="address.streetName" className="az-formfield__label">
                            {t("buyerSearch.streetName.label")}
                        </label>
                    </div>

                    <div className="col-sm-12 col-md-6 az-formfield">
                        
                        <input
                            type="text"
                            id="address.streetNumber"
                            name="address.streetNumber"
                            value={formData.address.streetNumber}
                            placeholder=""
                            onChange={handleChange}
                            className="az-formfield__input"
                        />
                        <label htmlFor="address.streetNumber" className="az-formfield__label">
                            {t("buyerSearch.streetNumber.label")}
                        </label>
                    </div>
                    <div className="col-sm-12 col-md-6 az-formfield">
                        
                        <input
                            type="text"
                            id="address.postalCode"
                            name="address.postalCode"
                            value={formData.address.postalCode}
                            placeholder=""
                            onChange={handleChange}
                            className="az-formfield__input"
                        />
                        <label htmlFor="address.postalCode" className="az-formfield__label">
                            {t("buyerSearch.postalCode.label")}
                        </label>
                    </div>

                    <div className="col-sm-12 col-md-6 az-formfield ">
                        
                        <input
                            type="text"
                            id="address.city"
                            name="address.city"
                            value={formData.address.city}
                            placeholder=""
                            onChange={handleChange}
                            className="az-formfield__input"
                        />
                        <label htmlFor="address.city" className="az-formfield__label">
                            {t("buyerSearch.city.label")}          
                        </label>
                    </div>

                </div>
                
                
                <div className="col-sm-12 az-formfield mt-2">
                    <FilteringSelect
                        id="address.countryCode"
                        name="address.countryCode"
                        value={formData.address.countryCode}
                        onChange={handleChange}
                        options={dropdownCountries}
                        label="buyerSearch.country.placeHolder"
                        disabled={!isEmpty(buyerInfo.address.countryCode)}
                    />
                </div>
                
                <div className="az-formfield col-12 mt-2">
                    
                    <input
                        type="text"
                        id="companyVATNumber"
                        name="companyVATNumber"
                        value={formData.companyVATNumber}
                        placeholder=""
                        onChange={handleChange}
                        className="az-formfield__input"
                        disabled={!isEmpty(buyerInfo.companyVATNumber)}
                    />
                    <label htmlFor="companyVATNumber" className="az-formfield__label">
                        {t("buyerSearch.id.label")}               
                    </label>
                </div>

                {isValidationError && <div className="text-danger">{t('buyerSearch.validationError.text')}</div>}
                {isTvaValidationError && <div className="text-danger">{t('buyerSearch.tvaValidationError.text')}</div>}

                <div className="mt-2 d-flex justify-content-start">
                    {isLoading ?
                        <div className="w-100 az-btn disabled" >
                            <Spinner size={24}/>
                        </div>
                        : 
                        <button onClick={handleSearch} className="w-100 az-btn">
                            {t("buyerSearch.search.btn")}
                        </button>
                    }
                </div>
            </form>
            
            {isPopinVisible && <BuyerSearchResult result={searchResult} onClose={closePopin} />}
        </>
    );
};

export default BuyerForm;